import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { Subscription, subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useVerifyPayment = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const verifyPayment = useCallback((reference: string) => {
    const url: HttpConfig = {
      url: 'auth-service/payments/verify',
      method: 'post',
      data: { reference },
    };
    return new Promise<Subscription>((resolve, reject) => {
      request(url, (response: SuccessHttpResponse<Subscription | null>) => {
        if (!response.data || response.data.status !== 'ACTIVE') {
          reject(new Error('Payment is not confirmed yet'));
          return;
        }
        dispatch(subscriptionActions.setCheckoutSession(null));
        resolve(response.data);
      }, setLoading, (err: AxiosError<ErrorHttpResponse>) => {
        const message = err?.response?.data?.message ?? 'Failed to verify payment';
        dispatch(subscriptionActions.setError(message));
        reject(new Error(message));
      });
    });
  }, [dispatch, request]);

  return { verifyPayment, loading };
};

export default useVerifyPayment;
